import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NOTES_TYPE, PAGE_NAMES, ROLES, ROLES_TYPE } from '../../../core/helpers/constants';
import { getRolesForPage } from '../../../core/helpers/utility';
import { UtilityService } from '../../../core/helpers/utility.service';
import { IPermission } from '../../../core/models/auth.models';
import { ILead } from '../../../core/models/lead.models';
import { P_AppDateFormat } from '../../../shared/shared.pipe';
import { AppService } from '../../../store/app.service';
import { LeadsApiService } from '../leads.apiservice';
import { InstanceService } from '../../../core/instance/instance.service';
import { LeadsService } from '../leads.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddLeadModal } from '../../../shared/modals/add-lead/add-lead.component';

@Component({
  selector: 'app-leads-details',
  templateUrl: './leads-details.component.html',
  styleUrls: ['./leads-details.component.scss']
})
export class LeadsDetailsComponent implements OnInit, OnDestroy {

  public ROLES = ROLES;
  doWhat: IPermission = {} as IPermission;

  leadData: ILead
  private leadId: string = '';
  active = 0;
  roleOptions: any = {};
  isExternal: boolean = false;
  public userRoles: Array<number> = [];
  private hasInitializedTabs = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    private uService: UtilityService,
    private route: ActivatedRoute,
    private appService: AppService,
    private leadsApiService: LeadsApiService,
    private leadsService: LeadsService,
    private modalService: NgbModal,
    private datePipe: P_AppDateFormat,
    public instance: InstanceService) {
    this.leadData = {} as ILead;
    this.userRoles = [...this.uService.getUserRoles()];
  }

  ngOnInit(): void {
    this.appService.setPageTitle$('LEADS');
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Leads);

    this.route.params.subscribe(params => {
      const id = params.id;
      this.leadId = id;
      if (id) {
        this.loadLead(id);
      }
    });

    this.appService.getLeadDetailsReload$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((reloadId: string | null) => {
        if (!reloadId) return;
        if (reloadId !== this.leadId) return;
        this.loadLead(reloadId);
      });
    this.appService.getActiveUser$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(u => {
        this.isExternal = u.type == ROLES_TYPE.External
      });
  }

  private loadLead(id: string) {
    this.leadsApiService.getLead(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.leadData = response.lead;
        if (!this.hasInitializedTabs) {
          this.hasInitializedTabs = true;
          this.activateTab(1);
        } else {
          this.loadDataForTab(this.active || 1);
        }
      });
  }

  onActiveTabChange(nextTabId: number): void {
    this.active = nextTabId;
    this.loadDataForTab(nextTabId);
  }

  private activateTab(tabId: number): void {
    Promise.resolve().then(() => {
      this.active = tabId;
      this.loadDataForTab(tabId);
    });
  }

  private loadDataForTab(tabId: number): void {
    if (!this.leadData?.id) {
      return;
    }

    if (tabId === 1) {
      this.appService.fetchAllNotes(this.leadData.id, NOTES_TYPE.Leads);
    }
  }

  updateIsMemberState(status : boolean){
    var request = {
      id: this.leadData.id,
      isMember: status
    }
    this.leadsApiService.updateIsMemberState(request)
    .pipe(takeUntil(this.destroyed$))
          .subscribe((response: any) => {
            this.leadData.isMember = status;
            this.leadData.memberSince = new Date();
          });
  }

  onEditLead(): void {
    if (!this.leadId) return;

    const dialogRef = this.modalService.open(AddLeadModal, { size: 'lg' });
    dialogRef.componentInstance.iId = this.leadId;
    dialogRef.componentInstance.oSaveClicked.subscribe(() => {
      this.appService.triggerLeadDetailsReload(this.leadId);
    });
  }

  onDeleteLead(): void {
    this.leadsService.deleteLeads();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  formatDate(date: Date) {
    return this.datePipe.transform(date, 'MM/DD/YYYY HH:mm');
  }
}
